"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    collapsed: false,
    items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    itemsById: {
      1: {
        id: 1,
        link: '#',
        img: 'https://tvlgiao.github.io/bigcommerce-themes/laparis/demo/images/brand01.png',
        alt: 'Sample Brand 1',
        text: '',
        collapsed: true,
        type: 'banner'
      },
      2: {
        id: 2,
        link: '#',
        img: 'https://tvlgiao.github.io/bigcommerce-themes/laparis/demo/images/brand02.png',
        alt: 'Sample Brand 2',
        text: '',
        collapsed: true,
        type: 'banner'
      },
      3: {
        id: 3,
        link: '#',
        img: 'https://tvlgiao.github.io/bigcommerce-themes/laparis/demo/images/brand03.png',
        alt: 'Sample Brand 3',
        text: '',
        collapsed: true,
        type: 'banner'
      },
      4: {
        id: 4,
        link: '#',
        img: 'https://tvlgiao.github.io/bigcommerce-themes/laparis/demo/images/brand04.png',
        alt: 'Sample Brand 4',
        text: '',
        collapsed: true,
        type: 'banner'
      },
      5: {
        id: 5,
        link: '#',
        img: 'https://tvlgiao.github.io/bigcommerce-themes/laparis/demo/images/brand05.png',
        alt: 'Sample Brand 5',
        text: '',
        collapsed: true,
        type: 'banner'
      },
      6: {
        id: 6,
        link: '#',
        img: 'https://tvlgiao.github.io/bigcommerce-themes/laparis/demo/images/brand01.png',
        alt: 'Sample Brand 6',
        text: '',
        collapsed: true,
        type: 'banner'
      },
      7: {
        id: 7,
        link: '#',
        img: 'https://tvlgiao.github.io/bigcommerce-themes/laparis/demo/images/brand02.png',
        alt: 'Sample Brand 7',
        text: '',
        collapsed: true,
        type: 'banner'
      },
      8: {
        id: 8,
        link: '#',
        img: 'https://tvlgiao.github.io/bigcommerce-themes/laparis/demo/images/brand03.png',
        alt: 'Sample Brand 8',
        text: '',
        collapsed: true,
        type: 'banner'
      },
      9: {
        id: 9,
        link: '#',
        img: 'https://tvlgiao.github.io/bigcommerce-themes/laparis/demo/images/brand04.png',
        alt: 'Sample Brand 9',
        text: '',
        collapsed: true,
        type: 'banner'
      },
      10: {
        id: 10,
        link: '#',
        img: 'https://tvlgiao.github.io/bigcommerce-themes/laparis/demo/images/brand05.png',
        alt: 'Sample Brand 10',
        text: '',
        collapsed: true,
        type: 'banner'
      }
    },
    itemNextId: 11
  };
}